const getShapeById = (id, activeGroup) => (
	activeGroup.views.map(view => view.shapes).flat().find((shape => shape.id === id)) || null
);

export {
	getShapeById
};